import CitySEOHead from "@/components/feature/CitySEOHead";
import OmahaHeroSection from "./components/HeroSection";
import OmahaStickyNav from "./components/StickyNav";
import OmahaProcessingTimeSection from "./components/ProcessingTimeSection";
import OmahaServicesSection from "./components/ServicesSection";
import OmahaLocalAreaSection from "./components/LocalAreaSection";
import OmahaTestimonialsSection from "./components/TestimonialsSection";
import OmahaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OmahaComparisonSection from "./components/ComparisonSection";
import OmahaMistakesSection from "./components/MistakesSection";
import OmahaHowItWorksSection from "./components/HowItWorksSection";
import OmahaFAQSection, { faqs } from "./components/FAQSection";
import OmahaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import OmahaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import OmahaTravelTimingSection from "./components/TravelTimingSection";
import OmahaDestinationsSection from "./components/DestinationsSection";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function OmahaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Omaha"
        state="Nebraska"
        stateAbbr="NE"
        route="/cities/omaha"
        title="Emergency Passport Omaha, NE — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Omaha, NE — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Offutt AFB STRATCOM families, Fortune 500 business travelers, Creighton and UNO students, and Eastern Nebraska residents."
        geoPlacename="Omaha, Nebraska"
        geoPosition="41.2565;-95.9345"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Nebraska"
        statePageRoute="/states/nebraska"
      />
      <OmahaHeroSection />
      <OmahaStickyNav />
      <OmahaProcessingTimeSection />
      <OmahaServicesSection />
      <OmahaLocalAreaSection />
      <OmahaTravelTimingSection />
      <OmahaDestinationsSection />
      <OmahaTestimonialsSection />
      <OmahaAcceptanceFacilitiesSection />
      <OmahaComparisonSection />
      <OmahaMistakesSection />
      <OmahaHowItWorksSection />
      <OmahaFAQSection />
      <OmahaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/omaha" state="NE" />
      <OmahaFinalCTA />
    </div>
  );
}